// Section for import npm components ------------------------------------------------------------------------------------
import React from 'react';

// MUI components
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';

// Section for import custom components --------------------------------------------------------------------------------
import DisplayUtility from '@utils/DisplayUtility';

// import CommonUtility from '@utils/Common';

// Section for type definition -----------------------------------------------------------------------------------------
import DisplayUtilityClass from '@/types/utils/DisplayUtilityClass';

// import CommonUtilityClass from '@/types/CommonUtilityClass';
type ScoreReviewProps = {
  title: string;
  score: number;
  countViewers: number;
  isReview: boolean;
};
// const commonUtil: CommonUtilityClass = CommonUtility;

const CustomRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#00375F',
  },
  '& .MuiRating-iconHover': {
    color: '#00375F',
  },
  '@media (max-width: 767px)': {
    '& .MuiRating-icon': {
      fontSize: '16px', // 星の大きさを指定
      lineHeight: '24px', // lineHeightを指定
    },
  },
  '@media (min-width: 768px)': {
    '& .MuiRating-icon': {
      fontSize: '30px', // 星の大きさを指定
    },
  },
});

// CSSの共通使用する値を設定
const label = 'p-2 bg-gray-01 text-center text-base font-bold text-rf-black';

export default function TotalScoreRating(props: ScoreReviewProps) {
  const { title, score, countViewers, isReview } = props;
  const displayUtility: DisplayUtilityClass = DisplayUtility;

  return (
    <Box className="md:sticky md:z-10 md:top-4">
      <Typography variant="h3" className={`${label}`}>
        {title}
      </Typography>
      {isReview ? (
        <Box className="flex md:flex-wrap gap-x-[6%] max-md:gap-x-4 justify-between max-md:justify-center mt-8">
          <Box className="md:flex-basis-[58%] md:max-w-full max-md:leading-10">
            <Typography className="max-md:hidden w-24 mx-auto mb-3 h-6 leading-6 text-sm text-center bg-gray-01 rounded-sm">
              {countViewers}人の評価
            </Typography>
            <CustomRating
              name="half-rating-read"
              defaultValue={displayUtility.formatDecimalDigitToNumber(score)}
              precision={0.1}
              readOnly
            />
          </Box>
          <Box className="max-md:flex max-md:gap-x-5 md:flex-basis-[36%] md:max-w-full">
            <Typography className="text-7xl max-md:text-4xl text-rf-navy font-medium">
              {displayUtility.formatDecimalDigitToString(score)}
            </Typography>
            <Typography className="md:hidden max-md:mt-[10px] px-2 h-5 leading-5 text-xs text-center bg-gray-01 rounded-sm">
              {countViewers}人の評価
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box className="max-md:hidden mt-9">
          <Typography className="text-4xl text-center text-rf-navy font-bold ">評価なし</Typography>
        </Box>
      )}
    </Box>
  );
}
